import React from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const PopularCourseCartAimation = () => {
    return (
        <div className="row gy-4">
            <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                <Skeleton count={1} height={250} borderRadius={10} highlightColor='#b6b1b1' />
            </div>
            <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                <Skeleton count={1} height={250} borderRadius={10} highlightColor='#b6b1b1' />
            </div>
            <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                <Skeleton count={1} height={250} borderRadius={10} highlightColor='#b6b1b1' />
            </div>
            <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                <Skeleton count={1} height={250} borderRadius={10} highlightColor='#b6b1b1' />
            </div>
        </div>
    );
};

export default PopularCourseCartAimation;